<lcp-header></lcp-header>

<div class="repo-container">

  <div class="grid-r padding-0">
    <div class="grid-c padding-0">
      <!-- <h2>admin dashboard</h2> -->

      <div class="admin-dashboard-cards">
        <!-- <mat-card appearance="outlined" class="admin-dashboard-card">
          <ul class="padding-0">
            <li><a routerLink="/" class="link-secondary">Home</a></li>
            <br>
            <li><a routerLink="/work" class="link-secondary">Work</a></li>
            <li><a routerLink="/about" class="link-secondary">About</a></li>
            <li><a routerLink="/team" class="link-secondary">Team</a></li>
            <li><a routerLink="/contact" class="link-secondary">Contact</a></li>
            <br>
            <li><a routerLink="/terms" class="link-secondary">Terms</a></li>
            <li><a routerLink="/privacy" class="link-secondary">Privacy</a></li>
            <li><a routerLink="/cookies" class="link-secondary">Cookies</a></li>
            <hr class="margin-v-20">
            <li><a routerLink="/admin" class="link-secondary">Admin</a>
              <ul class="padding-v-10">
                <li><a routerLink="/admin/settings" class="link-secondary">Settings</a></li>
                <li><a routerLink="/admin/users" class="link-secondary">Users</a></li>
                <li><a routerLink="/admin/users" class="link-secondary">Messages</a></li>
                <li><a routerLink="/logout" class="link-secondary">log out</a></li>
              </ul>
            </li>
          </ul>
        </mat-card> -->

        <mat-card appearance="outlined" class="admin-dashboard-card repo-card">
          <h4>software repo</h4>

          <div class="padding-v-20">
            <a class="btn-tertiary" target="_blank" href="https://github.com/orgs/lowercase-productions/repositories">
              <i class="fa-brands fa-github"></i>
              lowercase-productions github
            </a>
          </div>

          <hr>

          <ul class="padding-v-20 padding-h-0">
            <div class="padding-bottom-20"><em>this site</em></div>
            <li class="margin-bottom-20">
              <a routerLink="/" class="btn-secondary">
                <!-- <i class="fa-solid fa-"></i> -->
                lcp_legacy_2
              </a>
              <a class="btn-tertiary" target="_blank" href="https://github.com/lowercase-productions/lcp_legacy_2">
                <i class="fa-brands fa-github"></i>
                github
              </a>
            </li>

            <li class="margin-bottom-20">
              <a routerLink="/demo/home-v1" class="btn-secondary">lcp-home-v1</a>
            </li>

            <hr class="margin-v-30">

            <div class="padding-bottom-20"><em>demos</em></div>

            <li class="margin-bottom-20">
              <a routerLink="/demo/cleanpowersf-forecast" class="btn-secondary is-disabled">
                <i class="fa-solid fa-sun"></i>
                cleanpowersf forecast widget
              </a>
              <a class="btn-tertiary" target="_blank" href="https://github.com/lowercase-productions/cleanpowersf_forecast_widget">
                <i class="fa-brands fa-github"></i>
                github
              </a>
            </li>

            <li class="margin-bottom-20">
              <a routerLink="/demo/degenkolb-2022" class="btn-secondary">
                <i class="fa-solid fa-book-open-cover"></i>
                degenkolb holiday card 2022
              </a>
              <a class="btn-tertiary" target="_blank" href="https://github.com/lowercase-productions/degenkolb_holiday_2022">
                <i class="fa-brands fa-github"></i>
                github
              </a>
            </li>


            <li class="margin-bottom-20">
              <a routerLink="/demo/hunterspoint-org" class="btn-secondary is-disabled">
                <i class="fa-solid fa-tent-double-peak"></i>
                hunterspoint.org
              </a>
              <a class="btn-tertiary" target="_blank" href="https://github.com/lowercase-productions/hunterspoint_org">
                <i class="fa-brands fa-github"></i>
                github
              </a>
            </li>

            <li class="margin-bottom-20">
              <!-- <a (click)="navigateToOakPark()" class="btn-secondary"> -->
              <a target="_blank" [href]="oakParkUrl" class="btn-secondary">

                <i class="fa-solid fa-person-dress"></i>
                oak park wedding gown cleaners
              </a>
              <a class="btn-tertiary" target="_blank" href="https://github.com/lowercase-productions/oak_park_wedding_gown_cleaners">
                <i class="fa-brands fa-github"></i>
                github
              </a>
            </li>
          </ul>
        </mat-card>
      </div>
    </div>
  </div>
</div>